import { ActionsType } from '@tock/shared/utils/connect';

export function refreshCalendar(
  actions: ActionsType,
  ticketTypeAccessToken?: string,
  businessId?: number
) {
  return actions.calendar.fetchOfferings(ticketTypeAccessToken, true, businessId).then(() => {
    actions.calendar.fetchV2(ticketTypeAccessToken, true, businessId);
  });
}
